export enum CsvColumns {
  RowNumber = 'RowNumber',
  UniqueID = 'UniqueID',
  LimitSetName = 'LimitSetName',
  RowType = 'RowType',
  RuleType = 'RuleType',
  FilterName = 'FilterName',
  FilterValue = 'FilterValue',
  Account = 'Account',
  TranslationLanguage = 'TranslationLanguage',
  TranslationValue = 'TranslationValue',
  Limits = 'Limits',
  Units = 'Units',
  Compliancelevel = 'Compliancelevel',
  Template = 'Template',
  'RP Code' = 'RP Code'
}

export enum GroupCsvColumns {
  UniqueID = 'UniqueID',
  RowType = 'RowType',
  RpCode = 'RpCode',
  RuleType = 'RuleType',
  Account = 'Account',
  TranslationLanguage = 'TranslationLanguage',
  TranslationValue = 'TranslationValue'
}
